<template>
  <div class="warp">
    <div v-if="hzc == 1" class="box">
      <div v-if="b == 1" class="boxs">
        <div class="choice">
          <div class="choiceLeft" style="margin-right: 30px">
            <div class="choiceLeftText" :class="[a == 2 ? 'class1' : '']" @click="message">
              快捷登录
            </div>
            <div v-show="a == 2" class="choiceLefts" />
          </div>
          <div class="choiceLeft">
            <div class="choiceLeftText" :class="[a == 1 ? 'class1' : '']" @click="pword">
              密码登录
            </div>
            <div v-show="a == 1" class="choiceLefts" />
          </div>
        </div>
        <div v-show="a == 1" class="content">
          <div class="contentTop">
            <el-form ref="passwordLogin" :model="ruleForma" :rules="rules">
              <el-form-item prop="username">
                <el-input v-model.trim="ruleForma.username" placeholder="请输入账号" @input="accountVerify" />
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model.trim="ruleForma.password" placeholder="请输入密码" show-password
                  @keyup.enter.native="submit" @input="passwordVerify" />
              </el-form-item>
            </el-form>
            <div class="contentTops">
                <div class="boxbsBtm">
                  <input v-model.trim="checkboxs" type="checkbox" @change="handleCheckboxChange">
                  <p>
                    我已阅读并同意&nbsp;<span class="pointer" @click="goNexts()">《{{ domainInfo.name }}服务协议》</span>
                  </p>
                </div>
                <span class="forgotPassword" @click="zhaoPassword">忘记密码？</span>
            </div>
            <el-button :style="loginBgColor ? 'background: #CCCCCC' : 'background: #FF5E51'
              " class="contentTopBtn" :loading="loading" :disabled="loginBgColor" style="margin-top: 50px"
              @click="submitAntiShaking" @keyup.enter.native="submitAntiShaking">
              登录
            </el-button>
          </div>
          <div class="contentBtm">
            <!-- 未注册的手机号验证成功后将自动注册  -->
          </div>
        </div>
        <div v-show="a == 2" class="content">
          <div class="contentTop">
            <el-form ref="duanxinFrom" :model="ruleFormb" :rules="rules">
              <el-form-item prop="phones" style="background: #f2f2f2">
                <span class="add86 shrink0">+86</span>
                <el-input v-model.trim="ruleFormb.phones" placeholder="请输入手机号" maxlength="11" @input="phoneVerify" />
              </el-form-item>
              <el-form-item prop="shortCode">
                <div class="dis_flex_between" style="width: 100%">
                  <el-input v-model.trim="ruleFormb.shortCode" placeholder="请输入验证码" style="width: 60%"
                    @input="codeVerify" />
                  <p type="button" :class="time > 0 ? 'nodivb notClick' : 'divb'" :disabled="disable"
                    @click="dongTaiMa">
                    {{ title }}
                  </p>
                </div>
              </el-form-item>
            </el-form>
            <div class="contentTops">
              <div class="boxbsBtm">
                <input v-model.trim="checkboxs" type="checkbox" @change="handleCheckboxChange">
                <p>
                  我已阅读并同意&nbsp;<span class="pointer" @click="goNexts()">《{{ domainInfo.name }}服务协议》</span>
                </p>
              </div>
            </div>
            <el-button ref="loginSubmit" class="contentTopBtn" style="margin-top: 50px" :style="loginBgColorPhone
              ? 'background: #CCCCCC'
              : 'background: #FF5E51'
              " :disabled="loginBgColorPhone" @keyup.enter.native="submits" @click="submits">登录</el-button>
          </div>
          <div class="contentBtm">
            未注册的手机号验证成功后将自动注册 
          </div>
        </div>
      </div>
      <div v-if="b == 2" class="boxs">
        <div class="weiXin">
          <div class="weiXinLeft" @click="weixins">密码登录</div>
          <div class="weiXinRight" @click="weixins">
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Login/mima.png" alt="" />
          </div>
        </div>
        <div class="weiXinName">微信登录</div>
        <div class="weiXinImg">
          <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Login/weixin.png" alt="" />
        </div>
        <div class="weiXinNames">
          请使用微信扫描二维码登录 "{{ domainInfo.name }}网校"
        </div>
        <!-- <div class="weiXinFoot">
          未注册的手机号验证成功后将自动注册 
        </div> -->
      </div>
    </div>
    <el-dialog width="600px" :visible.sync="imgCodeDio">
      <imgCode @codeBack="codeBack" v-if="imgCodeDio"></imgCode>
    </el-dialog>
  </div>
</template>
<script>

import Bus from "@/api/bus";
import { getDomain, setUserInfo, setToken } from "@/api/cookies";
import imgCode from "@/views/login/imgCode.vue";
import md5 from "js-md5";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: { imgCode },
  data() {
    return {
      domainInfo: getDomain(),
      loginBgColorPhone: true,
      loginBgColor: true,
      imgCodeDio: false,
      userSource: "PC端",
      hzc: 1,
      a: 2,
      b: 1,
      checkboxs: false,
      // 默认密码登录需要协议确认，独立入口可按展示需求关闭此项校验。
      requirePasswordAgreement: true,
      timer: null,
      disable: false,
      title: "获取验证码",
      time: 0,
      loading: false,
      ruleForma: {},
      ruleFormb: {
        phones: "",
        shortCode: "",
      },
      captcha: "",
      rules: {
        username: [
          { required: true, message: "账号不能为空", trigger: "blur" },
        ],
        phones: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入合法手机号",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 6, message: "密码不能长度小于6个字符", trigger: "blur" },
        ],
        shortCode: [
          { required: true, message: "手机验证码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    setTimeout(() => {
      if (!!this.ruleForma.username && !!this.ruleForma.password) {
        this.loginBgColor = false;
      }
      if (!!this.ruleFormb.phones && !!this.ruleFormb.shortCode) {
        this.loginBgColorPhone = false;
      }
    }, 1000);
  },
  created() {
    this.href = this.$route.query.href;
    this.domainInfo = getDomain();
    if (this.$route.query.hzc) {
      this.hzc = this.$route.query.hzc;
    } else {
      this.hzc = 1;
    }
  },
  methods: {
    async codeBack(val, vals) {
      this.imgCodeDio = false;
      if (val && vals) {
        if (this.time > 0) {
          return;
        }
        if (!/^[1]([3-9])[0-9]{9}$/.test(this.ruleFormb.phones)) {
          this.$message.error("手机号格式不正确");
          return;
        }
        if (this.ruleFormb.phones) {

          const secret = await homeClient.getSendSmsSecretKey();
          console.log(secret, 'secret');

          const localSecret = "jTwfQP7Q5iJHHsc2";
          console.log(this.ruleFormb.phones + vals + val + localSecret + secret.data, 'encryptedStr');

          const encryptedStr = md5(this.ruleFormb.phones + vals + val + localSecret + secret.data);
          await homeClient.sendCodeJxy({

            phone: this.ruleFormb.phones,
            imgId: vals,
            imgCode: val,
            encryptedStr: encryptedStr,
          }).then((res) => {
            if (res.code != 0) {
              this.$message.error(res.msg);
            } else {
              this.time = 60;
              this.$message.success(res.msg);
              var www = setInterval(() => {
                if (this.time < 1) {
                  this.title = "获取验证码";
                  this.disable = false;
                  clearInterval(www);
                } else {
                  this.title = this.time-- + "秒后重发";
                  this.disable = true;
                }
              }, 1000);
            }
          });
        } else {
          this.$message.error("请输入手机号");
        }
      }
    },
    accountVerify() {
      if (!!this.ruleForma.username && !!this.ruleForma.password && (!this.requirePasswordAgreement || this.checkboxs)) {
        this.loginBgColor = false;
      } else {
        this.loginBgColor = true;
      }
    },
    passwordVerify() {
      if (!!this.ruleForma.username && !!this.ruleForma.password && (!this.requirePasswordAgreement || this.checkboxs)) {
        this.loginBgColor = false;
      } else {
        this.loginBgColor = true;
      }
    },
    phoneVerify() {
      if (!!this.ruleFormb.phones && !!this.ruleFormb.shortCode && this.checkboxs) {
        this.loginBgColorPhone = false;
      } else {
        this.loginBgColorPhone = true;
      }
    },
    codeVerify() {
      if (!!this.ruleFormb.phones && !!this.ruleFormb.shortCode && this.checkboxs) {
        this.loginBgColorPhone = false;
      } else {
        this.loginBgColorPhone = true;
      }
    },
    goNext() {
      this.$emit("toRegister");
    },
   goNexts() {
      Bus.$emit('handleRegister', false)
      this.$router.push('/agreement')
    },
    // 显示登陆
    headDengLu() {
      this.hzc = 1;
    },
    // 找回密码
    zhaoPassword() {
      this.$emit("showForgot"); 
    },
    // 微信登录
    weixin() {
      this.b = 2;
    },
    // 密码登录
    weixins() {
      this.b = 1;
    },
    // 密码登录选择
    pword() {
      this.a = 1;
      this.$refs.passwordLogin.clearValidate();
    },
    // 短信登录选择
    message() {
      this.a = 2;
      this.$refs.duanxinFrom.clearValidate();
    },
    // 勾选框状态变化时更新按钮状态
    handleCheckboxChange() {
      if (this.a === 1) {
        this.accountVerify();
      } else {
        this.phoneVerify();
      }
    },
    submitAntiShaking() {
      this.timer = setTimeout(() => {
        this.loading = true;
        this.submit();
        clearTimeout(this.timer);
      }, 0);
    },
    submit() {
      // 验证表单
      this.$refs.passwordLogin.validate(async (valid) => {
        // 仅在入口要求协议确认时检查勾选状态。
        if (this.requirePasswordAgreement && !this.checkboxs) {
          this.$message.error("请阅读并同意服务协议");
          this.loading = false;
          return;
        }
        
        if (valid) {
          const res = await homeClient.loginByPwd({
            account: this.ruleForma.username,
            passWord: this.ruleForma.password,
            loginTypeCode: 2,
          })
          if (res.code == 0) {
          console.log(res, 'res');
          
            await setToken(res.data.token)
            localStorage.setItem('userId', res.data.userId)
            const userInfo = await homeClient.getUserInfo(res.data.userId)
            setUserInfo(userInfo.data)
              window.location.reload();
            this.loading = false;
          } else {
            this.loading = false;
          }
        }
      });
    },
    submits() {
      this.$refs.duanxinFrom.validate(async (valid) => {
        // 检查是否勾选了协议
        if (!this.checkboxs) {
          this.$message.error("请阅读并同意服务协议");
          return;
        }
        
        if (valid) {
          const res = await homeClient.loginBySms({
            smsTel: this.ruleFormb.phones,
            smsVerificationCode: this.ruleFormb.shortCode,
            loginTypeCode: 2,
          })

          if (res.code == 0) {
            await setToken(res.data.token)
            localStorage.setItem('userId', res.data.userId)
            const userInfo = await homeClient.getUserInfo(res.data.userId)
            setUserInfo(userInfo.data)
              window.location.reload(); 



          } else {
            this.$message.error(res.msg);
          }

        }
      });
    },
    async dongTaiMa() {
      if (this.time > 0) {
        return;
      }
      this.imgCodeDio = true;
    },
  },
};
</script>
<style lang="less" scoped>
.warp {
  width: 100%;

  .box {
    .boxs {
      background: #ffffff;
      border-radius: 10px;

      .weiXin {
        width: 100%;
        height: 54px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        .weiXinLeft {
          width: 67px;
          height: 22px;
          background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Login/yuanjiao.png");
          background-size: 100% 100%;
          margin: 0px 3px 4px 0px;
          text-align: center;
          line-height: 22px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #f15817;
          cursor: pointer;
        }

        .weiXinRight {
          width: 34px;
          height: 34px;
          margin-right: 20px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .choice {
        height: auto;
        margin: auto;
        margin-top: 10px;
        display: flex;
        align-items: center;

        .choiceLeft {
          width: auto;
          height: 35px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .choiceLeftText {
            width: auto;
            height: 24px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666;
            cursor: pointer;
          }

          .class1 {
            color: #ff4027;
            cursor: pointer;
          }

          .choiceLefts {
            margin: auto;
            margin-top: 8px;
            width: 30px;
            height: 3px;
            background: linear-gradient(90deg, #ff4027 0%, #ff5400 100%);
            border-radius: 2px;
          }
        }
      }

      .content {
        width: 100%;
        margin-top: 30px;

        .el-form-item {
          margin-bottom: 24px;
        }

        .contentTop {
          // width: 90%;
          // height: 263px;
          margin: auto;

          .el-input {
            width: 100%;
            height: 46px;
          }

          .contentTops {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          
          .boxbsBtm {
            width: 100%;
            height: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            input {
              margin: 0px 6px 0px 0px;
              width: 12px;
              height: 12px;
            }

            p {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #7b8196;
              white-space: nowrap;
            }

            span {
              color: #ff4027;
            }
          }
          
          .forgotPassword {
            align-self: flex-end;
            font-size: 14px;
            color: #ff4027;
            cursor: pointer;
          }

          .contentTopBtn {
            width: 100%;
            height: 46px;
            margin-top: 16px;
            background: linear-gradient(90deg, #ff4027 0%, #ff5400 100%);
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }

        .contentBtm {
          margin-top: 20px;
          padding-bottom: 40px;
          width: 100%;
          border-radius: 0px 0px 10px 10px;
          text-align: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #7b8196;
          // cursor: pointer;

          span {
            color: #ff4027;
          }
        }
      }
    }
  }

  .boxb {
    width: 100%;
    height: 670px;
    background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Login/loginIcon682.png");
    background-size: 100% 100%;
    position: relative;
    margin-bottom: 40px;

    // 小盒子定位
    .boxbs {
      position: absolute;
      top: 70px;
      right: 360px;
      width: 380px;
      height: 510px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(222, 224, 228, 0.9);
      border-radius: 10px;

      // 缩宽
      .boxbss {
        width: 80%;
        height: 100%;
        margin: auto;

        .boxbsName {
          width: 163px;
          height: 17px;
          margin: 30px auto;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ff4027;
        }

        .boxbssHd {
          width: 222px;
          height: 35px;
          margin: 0px auto;
          margin-top: 54px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .imga {
            width: 24px;
            height: 35px;
          }

          .imgb {
            width: 124px;
            height: 4px;
          }

          .imgc {
            width: 24px;
            height: 18px;
          }
        }

        .boxbssHdp {
          width: 100%;
          height: 12px;
          margin-top: 40px;
          text-align: center;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #a8abbe;

          span {
            color: #333333;
          }
        }

        .el-form {
          .boxbssHdBtn {
            width: 87px;
            height: 40px;
            outline: none;
            background: #eeeeee;
            border: none;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ff4027;
            cursor: pointer;
          }
        }

        .boxbsBtn {
          width: 320px;
          height: 46px;
          margin: 22px auto;
          background: linear-gradient(90deg, #ff4027 0%, #ff5400 100%);
          box-shadow: 0px 2px 8px 0px rgba(203, 25, 0, 0.28);
          border-radius: 23px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .boxbsBtm {
          width: 100%;
          height: 13px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          input {
            margin: 0px 6px 0px 21px;
          }

          p {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #7b8196;

            span {
              color: #ff4027;
            }
          }
        }
      }
    }
  }

  .boxc {
    width: 100%;
    margin-bottom: 40px;
    height: 740px;
    background: #f3f4f7;
    overflow: hidden;

    .boxcs {
      width: 1200px;
      height: 630px;
      margin: auto;
      margin-top: 40px;
      background: #ffffff;
      overflow: hidden;
      position: relative;

      .boxcsHead {
        width: 80px;
        height: 18px;
        margin: 30px 0px 0px 30px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #27323f;
      }

      .line {
        width: 960px;
        height: 1px;
        margin: auto;
        margin-top: 84px;
        background: #e3e3e3;
      }

      .boxcsCent {
        width: 430px;
        height: 200px;
        margin: auto;
        margin-top: 122px;

        .boxcsCents {
          width: 100%;
          height: 46px;
          margin-bottom: 30px;
          display: flex;
          justify-content: flex-end;
          align-items: center;

          span {
            width: auto;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #27323f;
          }

          div {
            width: 96px;
            height: 40px;
            display: flex;
            margin-left: 14px;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ff7f48;
            cursor: pointer;
          }

          button {
            outline: none;
            border: none;
            width: 96px;
            height: 40px;
            display: flex;
            margin-left: 14px;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ff7f48;
            cursor: pointer;
          }
        }

        .zhQueren {
          width: 180px;
          height: 122px;
          margin: auto;
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
          }

          p {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #27323f;
          }
        }

        .boxcsCentss {
          width: 320px;
          height: 46px;
          border-radius: 2px;
          margin-left: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }
      }

      .boxcsFoot {
        width: 1140px;
        height: 96px;
        margin: auto;
        margin-top: 61px;
        background: #fff4ef;
        border-radius: 4px;
        overflow: hidden;

        .boxcsFoota {
          width: auto;
          height: auto;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #27323f;
          margin: 20px 0px 10px 20px;
        }

        .boxcsFootb {
          width: auto;
          height: auto;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #7b8196;
          margin: 0px 0px 3px 20px;
        }
      }

      .phone {
        position: absolute;
        top: 213px;
        left: 397px;
        z-index: 999999;
        width: 180px;
        height: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #27323f;

        p {
          width: auto;
          height: auto;
        }

        span {
          width: auto;
          height: auto;
        }
      }

      // 定位图片1
      .boxcsImga {
        width: 68px;
        height: 68px;
        position: absolute;
        top: 98px;
        left: 164px;
        z-index: 999999;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .boxcsImgb {
        width: 68px;
        height: 68px;
        position: absolute;
        top: 98px;
        left: 432px;
        z-index: 999999;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .boxcsImgc {
        width: 68px;
        height: 68px;
        position: absolute;
        top: 98px;
        right: 432px;
        z-index: 999999;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .boxcsImgd {
        width: 68px;
        height: 68px;
        position: absolute;
        top: 98px;
        right: 164px;
        z-index: 999999;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .diva {
    width: 96px;
    height: 40px;
    border: 1px solid #dddddd;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .divb {
    width: 96px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999;
    border-radius: 2px;
    cursor: pointer;
  }

  .divb:hover {
    width: 96px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    // background: #ffffff;
    border-radius: 2px;
    cursor: pointer;
    // border: 1px solid #ff4027;
    color: #ff4027;
  }

  .weiXinName {
    width: 100%;
    height: 55px;
    text-align: center;
    line-height: 55px;
    font-size: 18px;
    margin-bottom: 17px;
  }

  .weiXinImg {
    width: 200px;
    height: 200px;
    border-radius: 2px;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .weiXinNames {
    margin: auto;
    margin-top: 20px;
    text-align: center;
    width: 169px;
    height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7b8196;
    line-height: 20px;
  }

  .weiXinFoot {
    margin: auto;
    margin-top: 33px;
    width: 380px;
    height: 70px;
    background: #f8f8f8;
    border-radius: 0px 0px 10px 10px;
    text-align: center;
    line-height: 70px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7b8196;
    cursor: pointer;

    span {
      color: #ff4027;
    }
  }
}

/deep/.el-input__inner {
  border: none !important;
  background: #f2f2f2 !important;
}

/deep/.el-form-item__content {
  display: flex;
  height: 40px;
}

/deep/.el-form-item__error {}

/deep/.el-input__inner:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #f2f2f2 inset !important;
  background-color: #f2f2f2 !important;
}

.dis_flex_between {
  background: #f2f2f2;
}
</style>
